<template>
  <a-card
    size="small"
    title="查询"
    :headStyle="{
      background: '#f3f3f3',
    }"
  >
    <a-form layout="inline">
      <!-- <a-form-item>
        <a-range-picker
          v-model:value="searchForm.date"
          valueFormat="YYYY-MM-DD"
          format="YYYY-MM-DD"
        />
      </a-form-item> -->
      <a-form-item>
        <a-input
          placeholder="请输入姓名"
          v-model:value="searchForm.name"
        ></a-input>
      </a-form-item>
      <a-form-item>
        <a-select v-model:value="searchForm.state" style="width: 192px">
          <a-select-option
            v-for="(item, index) in stateList"
            :key="index"
            :value="item.val"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item>
        <a-button type="primary" @click="searchAction"> 查询 </a-button>
      </a-form-item>
      <a-form-item>
        <a-button @click="reset">重置</a-button>
      </a-form-item>

      <a-form-item :wrapper-col="{ offset: 4 }">
        <a-button type="primary" @click="templateDownload">下载模板</a-button>
      </a-form-item>
      <a-form-item :wrapper-col="{ offset: 10 }" style="width: 100px">
        <a-upload
          :fileList="fileList"
          :remove="handleRemove"
          accept=".xlsx,.xls"
          :beforeUpload="beforeUpload"
        >
          <a-button type="primary">上传</a-button>
        </a-upload>
      </a-form-item>
      <div style="margin-top: 10px"></div>
    </a-form>
  </a-card>
  <a-table
    :columns="columns"
    :dataSource="list"
    bordered
    :scroll="{ x: 2300 }"
    :loading="loading"
    :row-key="(r) => r"
  >
    <template v-slot:increase="{ text, record, index }">
      {{ index + 1 }}
    </template>
    <template #arr="{ text, record, index }">
      <span v-for="(item, index) in record.airSegs" :key="index">
        {{ item.arrTime }}
      </span>
    </template>
    <template #ticketStatus="{ text, record, index }">
      <span v-for="(item, index) in record.airSegs" :key="index">
        {{ item.ticketStatus }}
      </span>
    </template>

    <template #cabin="{ text, record, index }">
      <span v-for="(item, index) in record.airSegs" :key="index">
        {{ item.cabin }}
      </span>
    </template>
    <template #orgCity="{ text, record, index }">
      <span v-for="(item, index) in record.airSegs" :key="index">
        {{ item.orgCity }}
      </span>
    </template>

    <template #flightNo="{ text, record, index }">
      <span v-for="(item, index) in record.airSegs" :key="index">
        {{ item.flightNo }}
      </span>
    </template>
  </a-table>
</template>

<script>
import { reactive, ref } from "vue";
import search from "@axios/search";
import { exportOut } from "@axios/exportOut";
export default {
  setup() {
    //文件上传
    let handleRemove = (file) => {
      // 移除文件时，要重新给fileList赋值
      fileList.value.filter((item) => item.uid !== file.uid);
      // let arr = [];
      // for (let i = 0; i < fileList.value.length; i++) {
      //   if (fileList.value[i].uid !== file.uid) {
      //     arr.push(fileList.value[i]);
      //   }
      // }
      // fileList.value = arr;
    };
    let beforeUpload = (file) => {
      fileList.value = [...fileList.value, file];
      return false;
    };
    let fileList = ref([]);
    let templateDownload = () => {
      let params = {};
      let fileName = "模板";
      exportOut(
        params, // 导出请求参数
        "/app-finance/supplier/bill/download/template", // 接口地址
        fileName // 导出文件名字
      );
    };
    let list = ref([]);
    let loading = ref(false);
    let searchForm = reactive({
      name: "",
      state: 999,
      ticketNo: "",
      // date: [],
    });
    let searchParams = reactive({
      name: "",
      state: 999,
      ticketNo: "",
      // date: [],
    });
    let stateList = [
      {
        name: "全部",
        val: 999,
      },
      {
        name: "已退票",
        val: 1,
      },
      {
        name: "已完成",
        val: 2,
      },
    ];
    //test
    let searchPlane = () => {
      let xhr = new XMLHttpRequest();
      xhr.open("get", "http://localhost:3000/ticket");
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          let result = JSON.parse(xhr.responseText);
          result = result.data.tickets;
          list.value = result;
        }
      };
      xhr.send();
    };
    const searchAction = () => {
      searchParams.name = searchForm.name;
      searchParams.state = searchForm.state;
      searchParams.date = searchForm.date;
      console.log(searchParams);
      // pageObj.value = {
      //   page: 1,
      //   rows: 10,
      //   totle: 1,
      // };
      getList();
    };
    const getList = () => {
      loading.value = true;
      let params = {
        name: searchParams.name ? searchParams.name : null,
        ticketNo: searchParams.ticketNo ? searchParams.ticketNo : null,
        // createBeginTime: searchParams.date[0] ? searchParams.date[0] : null,
        // createEndTime: searchParams.date[1] ? searchParams.date[1] : null,
        // state : searchParams.state == 10?1:0,
        // currentPage: pageObj.value.page,
        // size: pageObj.value.rows,
      };

      // if (searchParams.state === 10) {
      //   params.state = 1;
      // } else if (searchParams.state === 20) {
      //   params.state = 0;
      // }

      search.searchOrder(params).then((res) => {
        console.log(res);
        loading.value = false;
        if (!res) return;
        // pageObj.value.totle = res.total;
        // pageObj.value.page = res.currentPage;
        list.value = res.data;
      });
    };
    let reset = () => {
      searchForm.name = "";
      searchForm.state = 999;
    };
    searchPlane();
    const layout = {
      labelCol: {
        span: 4,
      },
      wrapperCol: {
        span: 14,
      },
    };
    return {
      handleRemove,
      beforeUpload,
      fileList,
      layout,
      //下载模板
      templateDownload,
      searchPlane,
      searchParams,
      reset,
      stateList,
      list,
      loading,
      searchForm,
      searchAction,
      dataSource: [
        {
          passengerName: "张三",
          ticketNo: "731-2436006926",
          ticketPrice: "870.0",
          airSegs: "",
          arrTime: "2021-05-19 17:55:00",
          cabin: "T",
          depDate: "2021-05-19",
          depTime: "2021-05-19 15:10:00",
          distCity: "XIY",
          flightNo: "MF8269",
          orgCity: "FOC",
          ticketStatus: "未使用",
        },
      ],
      columns: [
        {
          title: "出发时间",
          align: "center",
          width: 20,
          slots: {
            customRender: "arr",
          },
        },
        {
          title: "序号",
          align: "center",
          width: 10,
          slots: {
            customRender: "increase",
          },
        },
        {
          title: "票号",
          align: "center",
          width: 30,
          dataIndex: "ticketNo",
        },

        {
          title: "航等",
          align: "center",
          width: 20,
          slots: {
            customRender: "cabin",
          },
        },
        {
          title: "航班号",
          align: "center",
          width: 20,
          slots: {
            customRender: "flightNo",
          },
        },
        {
          title: "票号状态",
          align: "center",
          width: 20,
          slots: {
            customRender: "ticketStatus",
          },
        },
        {
          title: "扫描时间",
          align: "center",
          width: 20,
        },
        {
          title: "乘客姓名",
          align: "center",
          width: 20,
          dataIndex: "passengerName",
        },
        {
          title: "票价",
          align: "center",
          width: 20,
          dataIndex: "ticketPrice",
        },
        {
          title: "航班号",
          align: "center",
          width: 20,
        },
        {
          title: "航等",
          align: "center",
          width: 20,
        },
        {
          title: "到达城市三字码",
          align: "center",
          width: 20,
          slots: {
            customRender: "orgCity",
          },
        },
        { title: "航段", align: "center", width: 20 },
      ],
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
// /deep/.ant-table-body {
//   &::-webkit-scrollbar {
//     height: 16px;
//   }
// }
/deep/.ant-upload-list-item-info:nth-child(1) {
  width: 300px;
}
</style>
